import type { RecordOf } from 'immutable';
import { Record as ImRecord, type List } from 'immutable';
import z from 'zod';

export enum CoaUsageTypeEnum {
  BUSINESS = 'BUSINESS',
  PERSONAL = 'PERSONAL',
  TRANSFER = 'TRANSFER',
  OTHER = 'OTHER',
}
export type CoaUsageType = `${CoaUsageTypeEnum}`;

export enum CoaTypeEnum {
  ACCOUNT = 'ACCOUNT',
  BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT',
  CATEGORY = 'CATEGORY',
  UNCATEGORIZED = 'UNCATEGORIZED',

  CATEGORY_USAGE_TYPE = 'CATEGORY_USAGE_TYPE',
  DISPLAY_NODE = 'DISPLAY_NODE',
  NONE = 'NONE',
}

export enum BalanceAdjustmentTypeEnum {
  BALANCE_ADJUSTMENT = '0',
  OPENING_BALANCE = '1',
  TRANSFER = '2',
  CREDIT_CARD_PAYMENT = '3',
}
export type BalanceAdjustmentType = `${BalanceAdjustmentTypeEnum}`;

const CoaTypeSchema = z
  .enum(['ACCOUNT', 'BALANCE_ADJUSTMENT', 'CATEGORY', 'UNCATEGORIZED', 'CATEGORY_USAGE_TYPE', 'DISPLAY_NODE', 'NONE'])
  .catch('NONE');
export type CoaType = z.infer<typeof CoaTypeSchema>;

export const ChartOfAccountSchema = z.object({
  type: CoaTypeSchema,
  id: z.string(),
});

export type ChartOfAccountProps = z.infer<typeof ChartOfAccountSchema>;
export type ChartOfAccount = RecordOf<ChartOfAccountProps>;

export const mkChartOfAccount = ImRecord<ChartOfAccountProps>({
  type: CoaTypeEnum.UNCATEGORIZED,
  id: '0',
});

export type ChartOfAccountNodeProps = {
  id?: null | string;
  coa?: null | ChartOfAccount;
  usageType?: null | CoaUsageType;

  name?: null | string;
  fullPathName?: null | string;
  fullPathNameWithoutUsageType?: null | string;

  path?: null | List<string>;
  children?: null | List<ChartOfAccountNode>;

  inList?: boolean;
};
export type ChartOfAccountNode = RecordOf<ChartOfAccountNodeProps>;
// FIXME: rename this to mkChartOfAccountNode
export const ChartOfAccountNode = ImRecord<ChartOfAccountNodeProps>({
  id: null,
  coa: null,

  usageType: null,

  name: null,
  fullPathName: null,
  fullPathNameWithoutUsageType: null,

  path: null,
  children: null,

  inList: true,
});

export const l1TransferCoa = mkChartOfAccount({
  type: CoaTypeEnum.BALANCE_ADJUSTMENT,
  id: BalanceAdjustmentTypeEnum.TRANSFER,
});

// Plain-props singletons for form state, which stores COAs as plain objects rather than Records (`l1TransferCoa` is
// the Record equivalent of the transfer COA). Frozen so a shared reference can never be mutated through a draft.
export const UNCATEGORIZED_COA: ChartOfAccountProps = Object.freeze({
  type: CoaTypeEnum.UNCATEGORIZED,
  id: '0',
});
export const TRANSFER_BALANCE_ADJUSTMENT_COA: ChartOfAccountProps = Object.freeze({
  type: CoaTypeEnum.BALANCE_ADJUSTMENT,
  id: BalanceAdjustmentTypeEnum.TRANSFER,
});
